import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWindowsIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "80%",
	height: "100%",
	viewBox: "0 0 48 48",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", { d: "M6 24V13.5L18 10.86V23.82L6 24ZM40 6V23.5L20 23.8V10.42L40 6ZM6 26L18 26.18V39.8L6 37.5V26ZM40 26.5V44L20 40.18V26.2L40 26.5Z" })]
});
const ForwardRef = forwardRef(SvgWindowsIcon);
export { ForwardRef as ReactComponent };
